// extracted by mini-css-extract-plugin
export default {"container":"Letter_container__06lJE","anonContainer":"Letter_anonContainer__55ebB"};